module.exports = __webpack_public_path__ + "img/15.a5f693eb.jpg";